// extracted by mini-css-extract-plugin
module.exports = {"articleTitle":"index-module--articleTitle--1TI6S","mainSectionBottomDemoContainer":"index-module--mainSectionBottomDemoContainer--b0Uc5"};